import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import { connect } from "react-redux";
import { Navigate, Routes, useLocation } from "react-router";
import { Route } from "react-router-dom";
import { AnyAction, bindActionCreators, Dispatch } from "redux";
import {
  isPublicPath,
  UrlPathAppContent,
  UrlPathAppContentCarousel,
  UrlPathAppContentCreate,
  UrlPathAppContentEdit,
  UrlPathAppContentLinks,
  UrlPathAppContentSplash,
  UrlPathBonus,
  UrlPathBonusCreate,
  UrlPathBonusViewMode,
  UrlPathBonusXpress,
  UrlPathCarouselCreate,
  UrlPathCarouselEdit,
  UrlPathCashback,
  UrlPathCircle,
  UrlPathCircleCreate,
  UrlPathCircleEdit,
  UrlPathConfigValueCreate,
  UrlPathConfigValueEdit,
  UrlPathCustomerDetails,
  UrlPathCustomerEdit,
  UrlPathCustomerPreferences,
  UrlPathCustomerSearch,
  UrlPathCustomField,
  URlPathDownloadFile,
  UrlPathFamily,
  UrlPathFlow,
  UrlPathFlowCreate,
  UrlPathFlowEdit,
  UrlPathGdpr,
  UrlPathCardDesign,
  UrlPathCardDesignCreate,
  UrlPathCardDesignEdit,
  UrlPathCardDesignLegacy,
  UrlPathInteractionSearch,
  URlPathLanding,
  UrlPathMain,
  UrlPathOperationalUnit,
  UrlPathOperationalUnitCreate,
  UrlPathOperationalUnitEdit,
  URlPathPkPassDownload,
  URlPathCardDownload,
  UrlPathPreferences,
  UrlPathPreferencesCreate,
  UrlPathPreferencesEdit,
  UrlPathReceiptScanningDetail,
  UrlPathReceiptScanning,
  UrlPathRegistration,
  UrlPathReports,
  UrlPathSegment,
  UrlPathSegmentBuilder,
  UrlPathSegmentBuilderAi,
  UrlPathSegmentBuilderCsv,
  UrlPathSegmentBuilderEasy,
  UrlPathSegmentCreate,
  UrlPathSegmentDetail,
  UrlPathUser,
  UrlPathUserCreate,
  UrlPathUserEdit,
  UrlPathReceiptDetail,
  UrlPathCoupon,
  UrlPathCouponCreate,
  UrlPathCouponEdit,
  UrlPathCampaignExperimental,
  UrlPathCampaignExperimentalCreate,
  UrlPathCampaignExperimentalEdit,
} from "../../api/url";
import keycloak from "../../keycloak";
import { thunkGetAllAppLinks } from "../../store/actions/AppLinkActions";
import { thunkGetBonusRules } from "../../store/actions/BonusRuleActions";
import { thunkGetBonusXpress } from "../../store/actions/BonusXpressActions";
import { thunkGetAllCircles } from "../../store/actions/CircleActions";
import { thunkGetAllConfigGroups } from "../../store/actions/ConfigGroupActions";
import { thunkGetAllEinGeneratorTemplates } from "../../store/actions/EinGeneratorTemplateAction";
import { thunkGetAllFlows } from "../../store/actions/FlowActions";
import { thunkGetAllCardDesigns } from "../../store/actions/CardDesignActions";
import {
  canMaintainAppContent,
  canMaintainBonus,
  canMaintainCircles,
  canMaintainConfig,
  canMaintainCustomers,
  canMaintainFamilies,
  canMaintainFlows,
  canMaintainCardDesigns,
  canMaintainOperationalUnits,
  canMaintainPreferences,
  canMaintainSegments,
  canMaintainUsers,
  canReadAppContent,
  canReadBonus,
  canReadCashBack,
  canReadCircles,
  canReadConfig,
  canReadCustomerInteractions,
  canReadCustomerPreferences,
  canReadCustomers,
  canReadDashboard,
  canReadFlows,
  canReadGdpr,
  canReadCardDesigns,
  canReadOperationalUnits,
  canReadPreferences,
  canReadReceipts,
  canReadReports,
  canReadUsers,
  canMaintainCoupons,
  canReadCoupons,
} from "../../store/actions/LoginActions";
import {
  thunkGetDefaultOperationalUnitTypes,
  thunkGetOperationalUnits,
} from "../../store/actions/OperationalUnitActions";
import { thunkGetQuestions } from "../../store/actions/PreferenceActions";
import { thunkFindAllUsers } from "../../store/actions/UserActions";
import { IStore } from "../../store/IStore";
import AppContentPage from "../appContent/AppContentPage";
import CarouselFormPage from "../appContent/carousel/AppContentCarouselFormPage";
import AppLinkFormPage from "../appContent/links/AppLinkFormPage";
import BonusRuleFormPage from "../bonusRule/BonusRuleFormPage";
import { BonusRulePage } from "../bonusRule/BonusRulePage";
import BonusXpressPage from "../bonusXpress/BonusXpressPage";
import CashbackPage from "../cashback/CashbackPage";
import ErrorPage from "../common/ErrorPage";
import CustomerCareDetailsPage from "../customerCare/CustomerCareDetailsPage";
import CustomerCareEditPage from "../customerCare/CustomerCareEditPage";
import CustomerCarePreferencesPage from "../customerCare/CustomerCarePreferencesPage";
import CustomerCareSearchPage from "../customerCare/CustomerCareSearchPage";
import FamilyPage from "../customerCare/FamilyPage";
import { MainDashboardPage } from "../dashboard/MainDashboardPage";
import Flows from "../flow/Flows";
import InteractionSearchPage from "../interactionSearch/InteractionSearchPage";
import OperationalUnitFormPage from "../operationalUnit/OperationalUnitFormPage";
import OperationalUnitOverview from "../operationalUnit/OperationalUnitOverview";
import PreferencesFormPage from "../preferences/PreferencesFormPage";
import { PreferencesPage } from "../preferences/PreferencesPage";
import { RegistrationPage } from "../registration/RegistrationPage";
import ReportPage from "../report/ReportPage";
import CreateCustomSegments from "../segments/builder/csv/CreateCustomSegments";
import SegmentsBuilder from "../segments/builder/SegmentsBuilder";
import AdHocSegmentsPage from "../segments/builder/adhoc/AdHocSegmentsPage";
import SegmentFormPage from "../segments/SegmentFormPage";
import SegmentsPage from "../segments/SegmentsPage";
import CircleFormPage from "../setup/circle/CircleFormPage";
import ConfigValueFormPage, { customFieldProps, receiptDetailProps } from "../setup/configValue/ConfigValueFormPage";
import CardDesignFormPage from "../setup/cardDesign/CardDesignFormPage";
import Setup from "../setup/Setup";
import UserFormPage from "../user/UserFormPage";
import { UserTablePage } from "../user/UserTablePage";
import LandingPage from "./LandingPage";
import PkPassDownloadPage from "./PkPassDownloadPage";
import DownloadFilePage from "./DownloadFilePage";
import CreateAiSegments from "../segments/builder/ai/CreateAiSegments";
import ReceiptOverview from "../receipt/ReceiptOverview";
import ReceiptEdit from "../receipt/ReceiptEdit";
import { CouponPage } from "../coupon/CouponPage";
import CouponFormPage from "../coupon/CouponFormPage";
import CouponEditPage from "../coupon/CouponEditPage";
import { CampaignPage as ExperimentalCampaignPage } from "../campaignExperimental/CampaignPage";
import CampaignCreatePage from "../campaignExperimental/CampaignCreatePage";

const RedirectLegacyCardDesignPath = () => {
  const { pathname, search } = useLocation();
  return <Navigate to={UrlPathCardDesign + pathname.slice(UrlPathCardDesignLegacy.length) + search} replace />;
};

const App = (props: ThunkProps) => {
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    keycloak.onAuthSuccess = () => {
      canReadPreferences() && props.thunkGetQuestions();
      canReadBonus() && props.thunkGetBonusRules();
      canReadBonus() && props.thunkGetBonusXpress();
      canReadOperationalUnits() && props.thunkGetOperationalUnits();
      canReadOperationalUnits() && props.thunkGetDefaultOperationalUnitTypes();
      canReadUsers() && props.thunkFindAllUsers();
      canReadCircles() && props.thunkGetAllCircles();
      canReadCardDesigns() && props.thunkGetAllCardDesigns();
      canReadFlows() && props.thunkGetAllFlows();
      canReadConfig() && props.thunkGetAllConfigGroups();
      canReadConfig() && props.thunkGetAllEinGeneratorTemplates();
    };

    keycloak.onAuthLogout = () => {
      keycloak.login();
    };
  }, [keycloak, props]);

  if (!initialized) {
    return <></>;
  }

  if (!keycloak.authenticated && !isPublicPath()) {
    keycloak.login();
    return <></>;
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/loyalty" replace />} />
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="/loyalty/login" element={<Navigate to="/" replace />} />
      <Route path={URlPathLanding} element={<LandingPage />} />
      <Route path={URlPathPkPassDownload} element={<PkPassDownloadPage />} />
      <Route path={URlPathCardDownload} element={<PkPassDownloadPage />} />
      <Route path={URlPathDownloadFile} element={<DownloadFilePage />} />
      <Route
        path={UrlPathMain}
        element={
          <AuthOrElse check={canReadDashboard} element={<MainDashboardPage />} pathToNavigate={UrlPathCustomerSearch} />
        }
      />
      <Route path={UrlPathReports} element={<Auth check={canReadReports} element={<ReportPage />} />} />
      <Route
        path={UrlPathInteractionSearch}
        element={<Auth check={canReadCustomerInteractions} element={<InteractionSearchPage />} />}
      />
      <Route
        path={UrlPathCustomerSearch}
        element={<Auth check={canReadCustomers} element={<CustomerCareSearchPage />} />}
      />
      <Route
        path={UrlPathCustomerEdit}
        element={<Auth check={canMaintainCustomers} element={<CustomerCareEditPage />} />}
      />
      <Route
        path={UrlPathCustomerDetails}
        element={<Auth check={canReadCustomers} element={<CustomerCareDetailsPage />} />}
      />

      <Route path={UrlPathPreferences} element={<Auth check={canReadPreferences} element={<PreferencesPage />} />} />
      <Route
        path={UrlPathPreferencesCreate}
        element={<Auth check={canMaintainPreferences} element={<PreferencesFormPage />} />}
      />
      <Route
        path={UrlPathPreferencesEdit}
        element={<Auth check={canMaintainPreferences} element={<PreferencesFormPage />} />}
      />
      <Route
        path={UrlPathCustomerPreferences}
        element={<Auth check={canReadCustomerPreferences} element={<CustomerCarePreferencesPage />} />}
      />
      <Route path={UrlPathBonusXpress} element={<Auth check={canReadBonus} element={<BonusXpressPage />} />} />
      <Route path={UrlPathAppContent} element={<Auth check={canReadAppContent} element={<AppContentPage />} />} />
      <Route path={UrlPathAppContentLinks} element={<Auth check={canReadAppContent} element={<AppContentPage />} />} />
      <Route
        path={UrlPathAppContentCarousel}
        element={<Auth check={canReadAppContent} element={<AppContentPage />} />}
      />
      <Route path={UrlPathAppContentSplash} element={<Auth check={canReadAppContent} element={<AppContentPage />} />} />
      <Route
        path={UrlPathAppContentCreate}
        element={<Auth check={canMaintainAppContent} element={<AppLinkFormPage />} />}
      />
      <Route
        path={UrlPathAppContentEdit}
        element={<Auth check={canMaintainAppContent} element={<AppLinkFormPage />} />}
      />
      <Route
        path={UrlPathCarouselCreate}
        element={<Auth check={canMaintainAppContent} element={<CarouselFormPage />} />}
      />
      <Route
        path={UrlPathCarouselEdit}
        element={<Auth check={canMaintainAppContent} element={<CarouselFormPage />} />}
      />
      <Route path={UrlPathBonus} element={<Auth check={canReadBonus} element={<BonusRulePage />} />} />
      <Route path={UrlPathBonusCreate} element={<Auth check={canMaintainBonus} element={<BonusRuleFormPage />} />} />
      <Route path={UrlPathBonusViewMode} element={<Auth check={canReadBonus} element={<BonusRuleFormPage />} />} />
      <Route path={UrlPathCashback} element={<Auth check={canReadCashBack} element={<CashbackPage />} />} />
      <Route
        path={UrlPathOperationalUnit}
        element={<Auth check={canReadOperationalUnits} element={<OperationalUnitOverview />} />}
      />
      <Route
        path={UrlPathOperationalUnitCreate}
        element={<Auth check={canMaintainOperationalUnits} element={<OperationalUnitFormPage />} />}
      />
      <Route
        path={UrlPathOperationalUnitEdit}
        element={<Auth check={canMaintainOperationalUnits} element={<OperationalUnitFormPage />} />}
      />
      <Route path={UrlPathSegment} element={<Auth check={canMaintainSegments} element={<SegmentsPage />} />} />
      <Route
        path={UrlPathSegmentBuilder}
        element={<Auth check={canMaintainSegments} element={<SegmentsBuilder />} />}
      />
      <Route
        path={UrlPathSegmentBuilderCsv}
        element={<Auth check={canMaintainSegments} element={<CreateCustomSegments />} />}
      />
      <Route
        path={UrlPathSegmentBuilderAi}
        element={<Auth check={canMaintainSegments} element={<CreateAiSegments />} />}
      />
      <Route
        path={UrlPathSegmentBuilderEasy}
        element={<Auth check={canMaintainSegments} element={<AdHocSegmentsPage />} />}
      />
      <Route path={UrlPathSegmentCreate} element={<Auth check={canMaintainSegments} element={<SegmentFormPage />} />} />
      <Route path={UrlPathSegmentDetail} element={<Auth check={canMaintainSegments} element={<SegmentFormPage />} />} />
      <Route path={UrlPathCircle} element={<Auth check={canReadCircles} element={<Setup />} />} />
      <Route path={UrlPathCircleCreate} element={<Auth check={canMaintainCircles} element={<CircleFormPage />} />} />
      <Route path={UrlPathCircleEdit} element={<Auth check={canMaintainCircles} element={<CircleFormPage />} />} />
      <Route path={UrlPathCardDesign} element={<Auth check={canReadCardDesigns} element={<Setup />} />} />
      <Route
        path={UrlPathCardDesignCreate}
        element={<Auth check={canMaintainCardDesigns} element={<CardDesignFormPage />} />}
      />
      <Route
        path={UrlPathCardDesignEdit}
        element={<Auth check={canMaintainCardDesigns} element={<CardDesignFormPage />} />}
      />
      <Route path={UrlPathCardDesignLegacy} element={<RedirectLegacyCardDesignPath />} />
      <Route path={UrlPathCardDesignLegacy + "/*"} element={<RedirectLegacyCardDesignPath />} />
      <Route path={UrlPathFlow} element={<Auth check={canReadFlows} element={<Flows />} />} />
      <Route path={UrlPathReceiptDetail} element={<Auth check={canReadConfig} element={<Setup />} />} />
      <Route path={UrlPathFlowCreate} element={<Auth check={canMaintainFlows} element={<Flows />} />} />
      <Route path={UrlPathFlowEdit} element={<Auth check={canMaintainFlows} element={<Flows />} />} />
      <Route
        path={UrlPathConfigValueCreate(UrlPathReceiptDetail)}
        element={<Auth check={canMaintainConfig} element={<ConfigValueFormPage {...receiptDetailProps} />} />}
      />
      <Route
        path={UrlPathConfigValueEdit(UrlPathReceiptDetail)}
        element={<Auth check={canMaintainConfig} element={<ConfigValueFormPage {...receiptDetailProps} />} />}
      />
      <Route path={UrlPathCustomField} element={<Auth check={canReadConfig} element={<Setup />} />} />
      <Route
        path={UrlPathConfigValueCreate(UrlPathCustomField)}
        element={<Auth check={canMaintainConfig} element={<ConfigValueFormPage {...customFieldProps} />} />}
      />
      <Route
        path={UrlPathConfigValueEdit(UrlPathCustomField)}
        element={<Auth check={canMaintainConfig} element={<ConfigValueFormPage {...customFieldProps} />} />}
      />
      <Route path={UrlPathGdpr} element={<Auth check={canReadGdpr} element={<Setup />} />} />
      <Route path={UrlPathUser} element={<Auth check={canReadUsers} element={<UserTablePage />} />} />
      <Route path={UrlPathUserCreate} element={<Auth check={canMaintainUsers} element={<UserFormPage />} />} />
      <Route path={UrlPathUserEdit} element={<Auth check={canMaintainUsers} element={<UserFormPage />} />} />
      <Route path={UrlPathRegistration} element={<RegistrationPage />} />
      <Route path={UrlPathFamily} element={<Auth check={canMaintainFamilies} element={<FamilyPage />} />} />
      <Route path={UrlPathReceiptScanning} element={<Auth check={canReadReceipts} element={<ReceiptOverview />} />} />
      <Route path={UrlPathReceiptScanningDetail} element={<Auth check={canReadReceipts} element={<ReceiptEdit />} />} />
      <Route path={UrlPathCoupon} element={<Auth check={canReadCoupons} element={<CouponPage />} />} />
      <Route path={UrlPathCouponCreate} element={<Auth check={canMaintainCoupons} element={<CouponFormPage />} />} />
      <Route path={UrlPathCouponEdit} element={<Auth check={canMaintainCoupons} element={<CouponEditPage />} />} />
      <Route
        path={UrlPathCampaignExperimental}
        element={<Auth check={canReadCoupons} element={<ExperimentalCampaignPage />} />}
      />
      <Route
        path={UrlPathCampaignExperimentalCreate}
        element={<Auth check={canMaintainCoupons} element={<CampaignCreatePage />} />}
      />
      <Route
        path={UrlPathCampaignExperimentalEdit}
        element={<Auth check={canMaintainCoupons} element={<CampaignCreatePage />} />}
      />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};

const Auth = ({ element, check }: { element: JSX.Element; check: () => boolean }) => (check() ? element : null);

const AuthOrElse = ({
  element,
  pathToNavigate,
  check,
}: {
  element: JSX.Element;
  pathToNavigate: string;
  check: () => boolean;
}) => {
  if (!keycloak.authenticated) {
    return null;
  }

  return check() ? element : <Navigate to={pathToNavigate} />;
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators(
    {
      thunkGetQuestions,
      thunkGetBonusRules,
      thunkGetOperationalUnits,
      thunkGetDefaultOperationalUnitTypes,
      thunkFindAllUsers,
      thunkGetAllAppLinks,
      thunkGetAllCircles,
      thunkGetAllCardDesigns,
      thunkGetAllFlows,
      thunkGetBonusXpress,
      thunkGetAllConfigGroups,
      thunkGetAllEinGeneratorTemplates,
    },
    dispatch
  );

type ThunkProps = ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: IStore) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(App);
